<template>
  <Card
    tone="default"
    padding="lg"
    :interactive="false"
    class="flex h-full flex-col gap-4 hover:shadow-md hover:shadow-accent/50"
  >
    <span
      class="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-accent-soft text-accent-strong"
    >
      <BaseIcon :name="iconName" :size="24" />
    </span>
    <h3 class="text-lg font-bold text-ink-strong md:text-xl">{{ title }}</h3>
    <p class="flex-1 text-sm text-ink-muted md:text-base">{{ description }}</p>
    <AnchorLink
      :hash="anchor"
      class="inline-flex items-center gap-1 text-sm font-semibold text-accent hover:text-accent-strong"
    >
      {{ ctaLabel }}
      <BaseIcon name="arrow-right" :size="16" />
    </AnchorLink>
  </Card>
</template>

<script setup lang="ts">
import Card from '@/components/primitives/Card.vue';
import BaseIcon from '@/components/base/BaseIcon.vue';
import AnchorLink from '@/components/navigation/AnchorLink.vue';
import type { IconName } from '@/components/base/icons';

interface Props {
  iconName: IconName;
  title: string;
  description: string;
  anchor: string;
  ctaLabel: string;
}

defineProps<Props>();
</script>
